import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import { Link } from 'react-router-dom';

export default function Home() {
  const [showPavillonForm, setShowPavillonForm] = useState(false);
  const [showFestivalForm, setShowFestivalForm] = useState(false);
  const [pavillonFormData, setPavillonFormData] = useState({
    nom: '',
    structure: '',
    activite: '',
    surface: '',
    contact: '',
    besoins: '',
    message: ''
  });
  const [festivalFormData, setFestivalFormData] = useState({
    nom: '',
    structure: '',
    activite: '',
    surface: '',
    contact: '',
    besoins: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const handlePavillonInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setPavillonFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFestivalInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFestivalFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePavillonSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    try {
      const emailResponse = await fetch('https://dcneykqhasdgepewqshp.supabase.co/functions/v1/send-email-notification', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          formType: 'pavillon',
          formData: pavillonFormData
        })
      });

      if (emailResponse.ok) {
        setSubmitStatus('Votre demande a été envoyée avec succès ! Nous vous répondrons dans les plus brefs délais.');
        setPavillonFormData({
          nom: '',
          structure: '',
          activite: '',
          surface: '',
          contact: '',
          besoins: '',
          message: ''
        });
        setShowPavillonForm(false);
      } else {
        setSubmitStatus('Une erreur est survenue. Veuillez réessayer.');
      }
    } catch (error) {
      setSubmitStatus('Une erreur est survenue. Veuillez réessayer.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleFestivalSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    try {
      const emailResponse = await fetch('https://dcneykqhasdgepewqshp.supabase.co/functions/v1/send-email-notification', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          formType: 'festival',
          formData: festivalFormData
        })
      });

      if (emailResponse.ok) {
        setSubmitStatus('Votre demande a été envoyée avec succès ! Nous vous répondrons dans les plus brefs délais.');
        setFestivalFormData({
          nom: '',
          structure: '',
          activite: '',
          surface: '',
          contact: '',
          besoins: '',
          message: ''
        });
        setShowFestivalForm(false);
      } else {
        setSubmitStatus('Une erreur est survenue. Veuillez réessayer.');
      }
    } catch (error) {
      setSubmitStatus('Une erreur est survenue. Veuillez réessayer.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section 
        id="accueil"
        className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/88d66907be07f80817ce48bf1dafede1.jpg')`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            Créons ensemble des événements
            <span className="block bg-gradient-to-r from-orange-400 to-amber-400 bg-clip-text text-transparent">
              porteurs de sens
            </span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto leading-relaxed">
            Agence de communication et d'événementiel spécialisée dans la création d'expériences uniques, inclusives et valorisant la diversité culturelle africaine.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact">
              <button className="inline-flex items-center justify-center font-medium transition-all duration-200 cursor-pointer whitespace-nowrap bg-gradient-to-r from-orange-500 to-amber-500 text-white hover:from-orange-600 hover:to-amber-600 shadow-lg hover:shadow-xl px-8 py-4 text-lg rounded-xl">
                <i className="ri-calendar-event-line mr-2"></i>
                Besoin d'infos
              </button>
            </Link>
            <Link to="/projects">
              <button className="inline-flex items-center justify-center font-medium transition-all duration-200 cursor-pointer whitespace-nowrap border-2 border-orange-500 text-orange-600 hover:bg-orange-500 hover:text-white px-8 py-4 text-lg rounded-xl">
                <i className="ri-play-circle-line mr-2"></i>
                Découvrir nos projets
              </button>
            </Link>
          </div>
        </div>
      </section>

      {/* Nos trois univers */}
      <section id="nos-prestations" className="py-20 bg-gradient-to-b from-orange-50 to-amber-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Nos trois univers
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Découvrez nos domaines d'expertise pour créer des événements mémorables et impactants
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Culture */}
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="h-64 bg-cover bg-center" style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=african%20cultural%20festival%20with%20traditional%20music%20instruments%2C%20colorful%20textiles%2C%20artisan%20crafts%2C%20vibrant%20market%20atmosphere%2C%20contemporary%20african%20art%2C%20cultural%20celebration%2C%20warm%20lighting%2C%20festival%20setting%20with%20diverse%20people%20enjoying%20cultural%20activities&width=400&height=300&seq=culture-universe&orientation=landscape')`
              }}></div>
              <div className="p-8">
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-r from-orange-500 to-amber-500 rounded-full mb-6">
                  <i className="ri-music-2-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Événements culturels</h3>
                <p className="text-gray-600 mb-6">
                  Festivals, marchés, Afrovidedressing marché de la mode africaine responsable et circulaire, concerts, videdressings et expositions célébrant la richesse culturelle africaine contemporaine.
                </p>
              </div>
            </div>

            {/* Institutionnel */}
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="h-64 bg-cover bg-center" style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=professional%20business%20conference%20with%20african%20business%20leaders%2C%20modern%20conference%20room%2C%20elegant%20corporate%20event%20setup%2C%20professional%20networking%20atmosphere%2C%20contemporary%20african%20business%20environment%2C%20warm%20professional%20lighting%2C%20diverse%20business%20professionals&width=400&height=300&seq=institutional-universe&orientation=landscape')`
              }}></div>
              <div className="p-8">
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-r from-orange-500 to-amber-500 rounded-full mb-6">
                  <i className="ri-building-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Événements institutionnels</h3>
                <p className="text-gray-600 mb-6">
                  Conférences, inaugurations, soirées partenaires et actions de sensibilisation pour valoriser les enjeux africains.
                </p>
              </div>
            </div>

            {/* Expériences immersives */}
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="h-64 bg-cover bg-center" style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=immersive%20african%20cultural%20workshop%20with%20participants%20learning%20traditional%20crafts%2C%20interactive%20cultural%20experience%2C%20hands-on%20activities%2C%20contemporary%20african%20art%20creation%2C%20collaborative%20learning%20environment%2C%20warm%20community%20atmosphere%2C%20diverse%20participants%20engaged&width=400&height=300&seq=immersive-universe&orientation=landscape')`
              }}></div>
              <div className="p-8">
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-r from-orange-500 to-amber-500 rounded-full mb-6">
                  <i className="ri-hand-heart-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Expériences immersives</h3>
                <p className="text-gray-600 mb-6">
                  Ateliers participatifs, défilés, afterworks et rencontres thématiques pour vivre la culture africaine de l'intérieur.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Projets phares */}
      <section id="projets-phares" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Nos projets phares
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Découvrez nos événements emblématiques qui célèbrent la créativité et l'innovation africaine
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">Pavillon Afrique</h3>
              <p className="text-lg text-gray-600 mb-6">
                Un espace économique, culturel et artistique dédié à l'Afrique contemporaine lors de la Foire Internationale de Nantes. 
                Le Pavillon Afrique met en lumière l'innovation, l'entrepreneuriat et la richesse culturelle du continent africain.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <button 
                  onClick={() => setShowPavillonForm(true)}
                  className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-orange-500 hover:bg-orange-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-store-line mr-2"></i>
                  Besoin d'infos
                </button>
                <a 
                  href="https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Formulaire%20d'inscription%20Pavillon%20Afrique/1%20%20Fiche%20d'admission%202026.pdf?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJGb3JtdWxhaXJlIGQnaW5zY3JpcHRpb24gUGF2aWxsb24gQWZyaXF1ZS8xICBGaWNoZSBkJ2FkbWlzc2lvbiAyMDI2LnBkZiIsImlhdCI6MTc2NjEzMTMxNSwiZXhwIjoxNzk3NjY3MzE1fQ.tOopjr6jpTLJmSfipqJYpBuk0SqKfho323z0SLibbtI"
                  target="_blank"
                  rel="noopener noreferrer"
                  download="Fiche_admission_Pavillon_Afrique_2026.pdf"
                  className="inline-flex items-center justify-center px-6 py-3 border border-orange-500 text-orange-600 hover:bg-orange-500 hover:text-white text-base font-medium rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-download-line mr-2"></i>
                  Réserver votre stand
                </a>
              </div>
            </div>
            <div className="h-96 bg-cover bg-center rounded-2xl shadow-xl" style={{
              backgroundImage: `url('https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/4d1476c57e22df7f98b50723a04c9770.jpeg')`
            }}></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
            <div className="lg:order-2">
              <h3 className="text-3xl font-bold text-gray-900 mb-6">Festival Afroverso</h3>
              <p className="text-lg text-gray-600 mb-6">
                Une célébration de la créativité africaine à travers la mode, la musique, l'art et l'innovation. 
                Le Festival Afroverso rassemble créateurs, artistes et innovateurs pour une expérience immersive 
                de la culture africaine contemporaine.
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-center space-x-3">
                  <i className="ri-music-line text-orange-600 text-xl"></i>
                  <span className="text-gray-700">Concerts live d'artistes africains émergents et confirmés</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-palette-line text-orange-600 text-xl"></i>
                  <span className="text-gray-700">Expositions d'art contemporain africain</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-lightbulb-line text-orange-600 text-xl"></i>
                  <span className="text-gray-700">Showcase d'innovations technologiques africaines</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-shopping-bag-line text-orange-600 text-xl"></i>
                  <span className="text-gray-700">Marché de créateurs et entrepreneurs africains</span>
                </div>
              </div>

              {/* Vidéo de concert */}
              <div className="bg-white rounded-lg shadow-md overflow-hidden mb-6">
                <video 
                  controls 
                  className="w-full h-64 object-cover"
                  poster="https://readdy.ai/api/search-image?query=African%20cultural%20concert%20video%20thumbnail%2C%20live%20music%20performance%2C%20vibrant%20stage%20lighting%2C%20audience%20enjoying%20african%20music%2C%20professional%20concert%20videography%20style%2C%20warm%20colors&width=600&height=300&seq=concert-video-thumb&orientation=landscape"
                >
                  <source 
                    src="https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Concert%201/Concert%201.mp4?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJDb25jZXJ0IDEvQ29uY2VydCAxLm1wNCIsImlhdCI6MTc2MjgwNTA2NywiZXhwIjoxNzk0MzQxMDY3fQ.9yjMcDMIUhTt4OMRrDRJTB7Y_jN1Z-1HTlysGeFCC1E" 
                    type="video/mp4"
                  />
                  Votre navigateur ne supporte pas la lecture vidéo.
                </video>
                <div className="p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">Concert Festival Afroverso</h4>
                  <p className="text-sm text-gray-600">Découvrez l'ambiance musicale unique de nos événements</p>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4">
                <button 
                  onClick={() => setShowFestivalForm(true)}
                  className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-orange-500 hover:bg-orange-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-store-line mr-2"></i>
                  Besoin d'infos
                </button>
                <Button variant="outline" href="/projects">
                  <i className="ri-image-line mr-2"></i>
                  Galerie photos/vidéos
                </Button>
              </div>
            </div>
            <div className="h-96 bg-cover bg-center rounded-2xl shadow-xl" style={{
              backgroundImage: `url('https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Afroverso/WhatsApp%20Image%202025-11-10%20at%2011.40.01%20(1).jpeg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJBZnJvdmVyc28vV2hhdHNBcHAgSW1hZ2UgMjAyNS0xMS0xMCBhdCAxMS40MC4wMSAoMSkuanBlZyIsImlhdCI6MTc2Mjc3MTM2MCwiZXhwIjoxNzk0MzA3MzYwfQ.fWtWBZ4pH1rQmsuai_UgKGErQjYMbjJRWH95Xf7pyx4')`
            }}></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">Afrovidedressing</h3>
              <p className="text-lg text-gray-600 mb-6">
                Un marché de la mode africaine responsable et circulaire qui promeut la consommation éthique. 
                L'Afrovidedressing permet de donner une seconde vie aux vêtements africains tout en célébrant 
                la beauté et l'authenticité du style africain contemporain.
              </p>
              <div className="space-y-4 mb-8">
                <div className="flex items-center space-x-3">
                  <i className="ri-recycle-line text-orange-600 text-xl"></i>
                  <span className="text-gray-700">Mode circulaire et responsable</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-shirt-line text-orange-600 text-xl"></i>
                  <span className="text-gray-700">Vêtements africains authentiques</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-heart-line text-orange-600 text-xl"></i>
                  <span className="text-gray-700">Consommation éthique et durable</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-community-line text-orange-600 text-xl"></i>
                  <span className="text-gray-700">Décoration</span>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-4">
                <Button href="/projects">
                  <i className="ri-shopping-bag-line mr-2"></i>
                  Participer
                </Button>
                <Button variant="outline" href="/projects">
                  <i className="ri-calendar-line mr-2"></i>
                  Prochaines dates
                </Button>
              </div>
            </div>
            
            <div className="space-y-4">
              {/* Vidéo Afrovidedressing */}
              <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <video 
                  controls 
                  className="w-full h-64 object-cover"
                  poster="https://readdy.ai/api/search-image?query=African%20sustainable%20fashion%20video%20thumbnail%2C%20Afrovidedressing%20event%2C%20circular%20fashion%20market%2C%20colorful%20african%20clothing%2C%20eco-friendly%20fashion%20showcase%2C%20professional%20event%20videography%20style&width=600&height=300&seq=afrovidedressing-video-thumb&orientation=landscape"
                >
                  <source 
                    src="https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Afrovidedressing%20video/WhatsApp%20Video%202025-11-10%20at%2014.11.49.mp4?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJBZnJvdmlkZWRyZXNzaW5nIHZpZGVvL1doYXRzQXBwIFZpZGVvIDIwMjUtMTEtMTAgYXQgMTQuMTEuNDkubXA0IiwiaWF0IjoxNzYyNzg2ODE5LCJleHAiOjE3OTQzMjI4MTl9.l_QTglrwiIef0QpjLJq7jDLiVuvagbQvWDX0aUgjpMg" 
                    type="video/mp4"
                  />
                  Votre navigateur ne supporte pas la lecture vidéo.
                </video>
                <div className="p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">Afrovidedressing - Mode Circulaire</h4>
                  <p className="text-sm text-gray-600">Découvrez l'ambiance de notre marché de la mode africaine responsable</p>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <img 
                  src="https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Afrovidedressing/Lewing%201.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJBZnJvdmlkZWRyZXNzaW5nL0xld2luZyAxLmpwZyIsImlhdCI6MTc2MjUyNTEyOCwiZXhwIjoxNzk0MDYxMTI4fQ.ovjs8BjMcIPUzS-3NjagfLzP4ar6cb-tJpZG8JF9Cpk"
                  alt="Événement Lewing - Mode africaine"
                  className="w-full h-48 object-cover object-top rounded-lg shadow-md"
                />
                <img 
                  src="https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Afrovidedressing/534A1917.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJBZnJvdmlkZWRyZXNzaW5nLzUzNEExOTE3LmpwZyIsImlhdCI6MTc2MjUyNTQwNSwiZXhwIjoxNzk0MDYxNDA1fQ.Sy57i1QSvQFbpTNckGffZMDjBOturnOaHKsziDr-LSE"
                  alt="Événement culturel - Moment de convivialité"
                  className="w-full h-48 object-cover object-top rounded-lg shadow-md"
                />
                <img 
                  src="https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Afrovidedressing/Achats%201.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJBZnJvdmlkZWRyZXNzaW5nL0FjaGF0cyAxLmpwZyIsImlhdCI6MTc2MjUyNjQzNywiZXhwIjoxNzk0MDYyNDM3fQ.GLjobIIzwYV2wWwyHaUmJJTKfiOfxRW-Y-cR1rwbEB8"
                  alt="Pavillon Afrique - Achats"
                  className="w-full h-48 object-cover object-top rounded-lg shadow-md"
                />
                <img 
                  src="https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Afrovidedressing/sweety.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJBZnJvdmlkZWRyZXNzaW5nL3N3ZWV0eS5qcGciLCJpYXQiOjE3NjI1MjU3MDcsImV4cCI6MTc5NDA2MTcwN30.1UdBHrz2Xe1J7IapKJKW_vpEYmwarncXyOTYtq0Nb6M"
                  alt="Événement Sweety - Moment culturel"
                  className="w-full h-48 object-cover object-top rounded-lg shadow-md"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Formulaire Pavillon Afrique */}
      {showPavillonForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-8">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold text-gray-900">Demande d'information - Pavillon Afrique</h2>
                <button 
                  onClick={() => setShowPavillonForm(false)}
                  className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>
              
              <form onSubmit={handlePavillonSubmit} data-readdy-form id="pavillon-form" className="space-y-6">
                <div>
                  <label htmlFor="pavillon-nom" className="block text-sm font-medium text-gray-700 mb-2">
                    Nom/Prénom *
                  </label>
                  <input
                    type="text"
                    id="pavillon-nom"
                    name="nom"
                    value={pavillonFormData.nom}
                    onChange={handlePavillonInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                    placeholder="Votre nom et prénom"
                  />
                </div>

                <div>
                  <label htmlFor="pavillon-structure" className="block text-sm font-medium text-gray-700 mb-2">
                    Structure/Entreprise *
                  </label>
                  <input
                    type="text"
                    id="pavillon-structure"
                    name="structure"
                    value={pavillonFormData.structure}
                    onChange={handlePavillonInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                    placeholder="Nom de votre structure ou entreprise"
                  />
                </div>

                <div>
                  <label htmlFor="pavillon-activite" className="block text-sm font-medium text-gray-700 mb-2">
                    Activité/Secteur *
                  </label>
                  <select
                    id="pavillon-activite"
                    name="activite"
                    value={pavillonFormData.activite}
                    onChange={handlePavillonInputChange}
                    required
                    className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                  >
                    <option value="">Sélectionnez votre secteur</option>
                    <option value="artisanat">Artisanat</option>
                    <option value="mode-textile">Mode et textile</option>
                    <option value="alimentation">Alimentation</option>
                    <option value="cosmetique">Cosmétique</option>
                    <option value="art-culture">Art et culture</option>
                    <option value="technologie">Technologie</option>
                    <option value="services">Services</option>
                    <option value="autre">Autre</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="pavillon-surface" className="block text-sm font-medium text-gray-700 mb-2">
                    Surface souhaitée
                  </label>
                  <select
                    id="pavillon-surface"
                    name="surface"
                    value={pavillonFormData.surface}
                    onChange={handlePavillonInputChange}
                    className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                  >
                    <option value="">Sélectionnez une surface</option>
                    <option value="6m2">6 m²</option>
                    <option value="9m2">9 m²</option>
                    <option value="12m2">12 m²</option>
                    <option value="18m2">18 m²</option>
                    <option value="plus-18m2">Plus de 18 m²</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="pavillon-contact" className="block text-sm font-medium text-gray-700 mb-2">
                    Contact *
                  </label>
                  <input
                    type="text"
                    id="pavillon-contact"
                    name="contact"
                    value={pavillonFormData.contact}
                    onChange={handlePavillonInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                    placeholder="Email ou téléphone"
                  />
                </div>

                <div>
                  <label htmlFor="pavillon-besoins" className="block text-sm font-medium text-gray-700 mb-2">
                    Besoins techniques
                  </label>
                  <input
                    type="text"
                    id="pavillon-besoins"
                    name="besoins"
                    value={pavillonFormData.besoins}
                    onChange={handlePavillonInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                    placeholder="Électricité, éclairage, mobilier..."
                  />
                </div>

                <div>
                  <label htmlFor="pavillon-message" className="block text-sm font-medium text-gray-700 mb-2">
                    Message
                  </label>
                  <textarea
                    id="pavillon-message"
                    name="message"
                    value={pavillonFormData.message}
                    onChange={handlePavillonInputChange}
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm resize-none"
                    placeholder="Décrivez votre projet..."
                  />
                  <p className="text-xs text-gray-500 mt-1">
                    {pavillonFormData.message.length}/500 caractères
                  </p>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-orange-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-orange-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                >
                  {isSubmitting ? 'Envoi en cours...' : 'Envoyer la demande'}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Formulaire Festival */}
      {showFestivalForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-8">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold text-gray-900">Inscription Exposant/Créateur - Festival Afroverso</h2>
                <button 
                  onClick={() => setShowFestivalForm(false)}
                  className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>
              
              <form onSubmit={handleFestivalSubmit} data-readdy-form id="festival-form" className="space-y-6">
                <div>
                  <label htmlFor="festival-nom" className="block text-sm font-medium text-gray-700 mb-2">
                    Nom/Prénom *
                  </label>
                  <input
                    type="text"
                    id="festival-nom"
                    name="nom"
                    value={festivalFormData.nom}
                    onChange={handleFestivalInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                    placeholder="Votre nom et prénom"
                  />
                </div>

                <div>
                  <label htmlFor="festival-structure" className="block text-sm font-medium text-gray-700 mb-2">
                    Marque/Nom d'artiste *
                  </label>
                  <input
                    type="text"
                    id="festival-structure"
                    name="structure"
                    value={festivalFormData.structure}
                    onChange={handleFestivalInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                    placeholder="Nom de votre marque ou nom d'artiste"
                  />
                </div>

                <div>
                  <label htmlFor="festival-activite" className="block text-sm font-medium text-gray-700 mb-2">
                    Domaine d'activité *
                  </label>
                  <select
                    id="festival-activite"
                    name="activite"
                    value={festivalFormData.activite}
                    onChange={handleFestivalInputChange}
                    required
                    className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                  >
                    <option value="">Sélectionnez votre domaine</option>
                    <option value="mode-vetements">Mode et vêtements</option>
                    <option value="afrovidedressing">Afrovidedressing (mode circulaire)</option>
                    <option value="art-contemporain">Art contemporain</option>
                    <option value="artisanat-traditionnel">Artisanat traditionnel</option>
                    <option value="musique">Musique</option>
                    <option value="innovation-technologique">Innovation technologique</option>
                    <option value="cosmetique-naturelle">Cosmétique naturelle</option>
                    <option value="alimentation">Alimentation</option>
                    <option value="autre">Autre</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="festival-surface" className="block text-sm font-medium text-gray-700 mb-2">
                    Type de stand souhaité
                  </label>
                  <select
                    id="festival-surface"
                    name="surface"
                    value={festivalFormData.surface}
                    onChange={handleFestivalInputChange}
                    className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                  >
                    <option value="">Sélectionnez un type de stand</option>
                    <option value="stand-3m2-debutant">Stand 3m² - Créateur débutant</option>
                    <option value="stand-6m2-confirme">Stand 6m² - Créateur confirmé</option>
                    <option value="stand-9m2-etabli">Stand 9m² - Marque établie</option>
                    <option value="stand-12m2-premium">Stand 12m² - Exposition premium</option>
                    <option value="espace-performance">Espace performance - Artiste</option>
                    <option value="autre">Autre (préciser dans le message)</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="festival-contact" className="block text-sm font-medium text-gray-700 mb-2">
                    Contact *
                  </label>
                  <input
                    type="email"
                    id="festival-contact"
                    name="contact"
                    value={festivalFormData.contact}
                    onChange={handleFestivalInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                    placeholder="Email de contact"
                  />
                </div>

                <div>
                  <label htmlFor="festival-besoins" className="block text-sm font-medium text-gray-700 mb-2">
                    Besoins techniques et logistiques
                  </label>
                  <input
                    type="text"
                    id="festival-besoins"
                    name="besoins"
                    value={festivalFormData.besoins}
                    onChange={handleFestivalInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                    placeholder="Électricité, éclairage, mobilier, sonorisation..."
                  />
                </div>

                <div>
                  <label htmlFor="festival-message" className="block text-sm font-medium text-gray-700 mb-2">
                    Présentation de votre projet/création
                  </label>
                  <textarea
                    id="festival-message"
                    name="message"
                    value={festivalFormData.message}
                    onChange={handleFestivalInputChange}
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm resize-none"
                    placeholder="Décrivez votre univers créatif, vos produits, votre démarche artistique..."
                  />
                  <p className="text-xs text-gray-500 mt-1">
                    {festivalFormData.message.length}/500 caractères
                  </p>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-orange-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-orange-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                >
                  {isSubmitting ? 'Envoi en cours...' : 'Envoyer'}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Message de statut */}
      {submitStatus && (
        <div className="fixed bottom-4 right-4 max-w-md z-50">
          <div className={`p-4 rounded-lg shadow-lg ${
            submitStatus.includes('succès') 
              ? 'bg-green-50 text-green-800 border border-green-200' 
              : 'bg-red-50 text-red-800 border border-red-200'
          }`}>
            <div className="flex items-center justify-between">
              <span className="text-sm">{submitStatus}</span>
              <button 
                onClick={() => setSubmitStatus('')}
                className="ml-4 text-gray-400 hover:text-gray-600 cursor-pointer"
              >
                <i className="ri-close-line"></i>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Call to Action */}
      <section id="contact" className="py-20 bg-gradient-to-r from-orange-500 to-amber-500">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Prêt à créer votre événement ?
          </h2>
          <p className="text-xl text-orange-100 mb-8">
            Contactez-nous pour discuter de votre projet et découvrir comment nous pouvons vous accompagner
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button variant="secondary" size="lg" href="/contact">
              <i className="ri-phone-line mr-2"></i>
              Nous contacter
            </Button>
            <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-orange-500">
              <i className="ri-download-line mr-2"></i>
              Télécharger notre brochure
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
